import {useEffect, useState} from 'react'
import { useField } from 'formik'
import styles from "../custom.module.css";
import { isFilled } from '../FormDetail'

export default function SelectDropdown({ options, label, initialValue, name }) {
    const [field, meta, helpers] = useField({ name })
    const { value, error } = meta;
    const { setValue } = helpers;
    const onChange = (e) => setValue(e.target.value)

    return (
        <div className={`SelectDropdown  ${isFilled(value) ? 'selected': ''}`}>
            <label className={'mb-0 SelectDropdown__label '} >{label}</label>
            <div>
                <select
                    value={value}
                    onChange={onChange}
                    >
                    <option value=""></option>
                    {options?.map((op, opIndex) => (
                        <option key={`${name}_${opIndex}`} value={op.value}>{op.label}</option>
                    ))}
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 SelectDropdown__righticon">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
                </svg>

            </div>
            {error && (
                    <p className={'text-danger small mt-2 select-error ' + styles.form_field_error}>{error}</p>
                )}
        </div>
    )
}